import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPanel.css';

const AdminPanel = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({
    users: 0,
    news: 0,
    alumni: 0,
    partners: 0,
    stories: 0,
    requests: 0
  });

  const [users, setUsers] = useState([]);
  const [alumni, setAlumni] = useState([]);
  const [news, setNews] = useState([]);
  const [partners, setPartners] = useState([]);
  const [stories, setStories] = useState([]);
  const [requests, setRequests] = useState([]);
  
  // Состояния для поиска
  const [searchUsers, setSearchUsers] = useState('');
  const [searchAlumni, setSearchAlumni] = useState('');
  const [searchNews, setSearchNews] = useState('');
  const [searchPartners, setSearchPartners] = useState('');
  const [searchStories, setSearchStories] = useState('');
  
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('');
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Проверка авторизации при загрузке
  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('adminToken');
      const userData = JSON.parse(localStorage.getItem('adminUser') || '{}');

      if (!token || userData.role !== 'admin') {
        navigate('/');
        return;
      }

      // Проверяем валидность токена
      try {
        const response = await fetch('/api/auth/me', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (!response.ok) {
          throw new Error('Токен недействителен');
        }
        
        const data = await response.json();
        setUser(data);
        loadStats();
      } catch (err) {
        console.error('Ошибка проверки токена:', err);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        navigate('/');
      }
    };
    
    checkAuth();
  }, [navigate]);

  useEffect(() => {
    if (activeTab !== 'dashboard') {
      loadTabData(activeTab);
    }
  }, [activeTab]);

  const loadStats = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch('/api/admin/stats', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        setStats(data.stats || { users: 0, news: 0, alumni: 0, partners: 0, stories: 0, requests: 0 });
      } else if (response.status === 401 || response.status === 403) {
        handleLogout();
      }
    } catch (err) {
      console.error('Ошибка загрузки статистики:', err);
    }
  };

  const loadTabData = async (tab) => {
    setLoading(true);
    setError('');
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        handleLogout();
        return;
      }
      
      switch(tab) {
        case 'users':
          const usersRes = await fetch('/api/admin/users', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (usersRes.ok) {
            const data = await usersRes.json();
            setUsers(Array.isArray(data) ? data : []);
          } else if (usersRes.status === 401 || usersRes.status === 403) {
            handleLogout();
          }
          break;
          
        case 'alumni':
          const alumniRes = await fetch('/api/admin/alumni', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (alumniRes.ok) {
            const data = await alumniRes.json();
            setAlumni(Array.isArray(data) ? data : []);
          } else if (alumniRes.status === 401 || alumniRes.status === 403) {
            handleLogout();
          }
          break;
          
        case 'news':
          const newsRes = await fetch('/api/admin/news', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (newsRes.ok) {
            const data = await newsRes.json();
            // Проверяем структуру ответа
            if (data.news && Array.isArray(data.news)) {
              setNews(data.news);
            } else if (Array.isArray(data)) {
              setNews(data);
            } else {
              setNews([]);
            }
          } else if (newsRes.status === 401 || newsRes.status === 403) {
            handleLogout();
          }
          break;
          
        case 'partners':
          const partnersRes = await fetch('/api/admin/partners', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (partnersRes.ok) {
            const data = await partnersRes.json();
            setPartners(Array.isArray(data) ? data : []);
          } else if (partnersRes.status === 401 || partnersRes.status === 403) {
            handleLogout();
          }
          break;
          
        case 'stories':
          const storiesRes = await fetch('/api/admin/success-stories', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (storiesRes.ok) {
            const data = await storiesRes.json();
            setStories(Array.isArray(data) ? data : []);
          } else if (storiesRes.status === 401 || storiesRes.status === 403) {
            handleLogout();
          }
          break;
          
        case 'requests':
          const requestsRes = await fetch('/api/admin/alumni-requests', {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (requestsRes.ok) {
            const data = await requestsRes.json();
            setRequests(Array.isArray(data) ? data : []);
          } else if (requestsRes.status === 401 || requestsRes.status === 403) {
            handleLogout();
          }
          break;
          
        default:
          break;
      }
    } catch (err) {
      console.error(`Ошибка загрузки ${tab}:`, err);
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    navigate('/');
  };

  const handleAdd = (type) => {
    setModalType(type);
    setEditingItem(null);
    setFormData(getEmptyForm(type));
    setSelectedFile(null);
    setImagePreview(null);
    setShowModal(true);
  };

  const handleEdit = (type, item) => {
    setModalType(type);
    setEditingItem(item);
    setFormData(item);
    setSelectedFile(null);
    setImagePreview(item.image_url || item.logo_url || null);
    setShowModal(true);
  };

  const getEmptyForm = (type) => {
    switch(type) {
      case 'user':
        return { fio: '', email: '', phone: '', university: '', role: 'user' };
      case 'alumni':
        return { 
          fio: '', 
          direction: '', 
          specialty: '', 
          graduation_year: '', 
          performance_year: '', 
          email: '', 
          phone: '', 
          position: '', 
          workplace: '', 
          location: '', 
          linkedin: '', 
          facebook: '',
          image_url: null
        };
      case 'news':
        return { 
          title: '', 
          description: '', 
          content: '', 
          date: new Date().toISOString().split('T')[0], 
          is_published: true,
          image_url: null
        };
      case 'partner':
        return { 
          name: '', 
          description: '', 
          website_url: '', 
          category: 'other', 
          is_featured: false, 
          display_order: 0,
          logo_url: null
        };
      case 'story':
        return { 
          name: '', 
          role: '', 
          description: '', 
          graduation: '', 
          category: 'other', 
          is_featured: false, 
          display_order: 0,
          image_url: null
        };
      default:
        return {};
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        handleLogout();
        return;
      }
      
      let url = '';
      let method = 'POST';
      
      switch(modalType) {
        case 'alumni':
          url = editingItem ? `/api/admin/alumni/${editingItem.id}` : '/api/admin/alumni';
          break;
        case 'news':
          url = editingItem ? `/api/admin/news/${editingItem.id}` : '/api/admin/news';
          break;
        case 'partner':
          url = editingItem ? `/api/admin/partners/${editingItem.id}` : '/api/admin/partners';
          break;
        case 'story':
          url = editingItem ? `/api/admin/success-stories/${editingItem.id}` : '/api/admin/success-stories';
          break;
        case 'user':
          url = editingItem ? `/api/admin/users/${editingItem.id}` : '/api/admin/users';
          break;
        default:
          return;
      }

      if (editingItem) {
        method = 'PUT';
      }

      // ========== СПЕЦИАЛЬНАЯ ОБРАБОТКА ДЛЯ ПОЛЬЗОВАТЕЛЕЙ ==========
      if (modalType === 'user') {
        // Отправляем как JSON, а не FormData
        const userData = {
          fio: formData.fio,
          email: formData.email,
          phone: formData.phone || '',
          university: formData.university || '',
          role: formData.role || 'user'
        };
        
        console.log('Отправка данных пользователя:', userData);
        
        const response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(userData)
        });

        if (response.ok) {
          alert(editingItem ? 'Пользователь обновлен' : 'Пользователь добавлен');
          setShowModal(false);
          await loadTabData('users');
          loadStats();
        } else {
          const data = await response.json();
          alert(data.error || 'Ошибка при сохранении');
        }
        return;
      }

      // ========== ДЛЯ ВСЕХ ОСТАЛЬНЫХ ТИПОВ (с файлами) ==========
      const formDataToSend = new FormData();
      
      // Обработка даты для новостей
      let processedFormData = { ...formData };
      if (modalType === 'news' && processedFormData.date) {
        processedFormData.date = processedFormData.date.split('T')[0];
      }
      
      Object.keys(processedFormData).forEach(key => {
        if (processedFormData[key] !== null && processedFormData[key] !== undefined) {
          if (key === 'image_url' || key === 'logo_url') {
            return;
          }
          
          if (typeof processedFormData[key] === 'object' && !(processedFormData[key] instanceof File)) {
            formDataToSend.append(key, JSON.stringify(processedFormData[key]));
          } else {
            if (typeof processedFormData[key] === 'boolean') {
              formDataToSend.append(key, processedFormData[key] ? 'true' : 'false');
            } else {
              formDataToSend.append(key, processedFormData[key]);
            }
          }
        }
      });
      
      if (selectedFile) {
        if (modalType === 'partner') {
          formDataToSend.append('logo', selectedFile);
        } else if (modalType === 'news') {
          formDataToSend.append('image', selectedFile);
        } else {
          formDataToSend.append('photo', selectedFile);
        }
      }
      
      if (imagePreview && !selectedFile && imagePreview.startsWith('data:')) {
        if (modalType === 'partner') {
          formDataToSend.append('existing_logo', imagePreview);
        } else {
          formDataToSend.append('existing_image', imagePreview);
        }
      }

      const response = await fetch(url, {
        method,
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formDataToSend
      });

      if (response.ok) {
        alert(editingItem ? 'Элемент обновлен' : 'Элемент добавлен');
        setShowModal(false);
        
        let tabToReload = '';
        switch(modalType) {
          case 'alumni': tabToReload = 'alumni'; break;
          case 'news': tabToReload = 'news'; break;
          case 'partner': tabToReload = 'partners'; break;
          case 'story': tabToReload = 'stories'; break;
        }
        if (tabToReload) {
          await loadTabData(tabToReload);
        }
        loadStats();
      } else if (response.status === 401 || response.status === 403) {
        handleLogout();
      } else {
        const data = await response.json();
        alert(data.error || 'Ошибка при сохранении');
      }
    } catch (err) {
      console.error('Ошибка сохранения:', err);
      alert('Ошибка при сохранении');
    }
  };

  const handleDelete = async (type, id) => {
    if (!window.confirm('Вы уверены, что хотите удалить этот элемент?')) return;
    
    try {
      const token = localStorage.getItem('adminToken');
      if (!token) {
        handleLogout();
        return;
      }
      
      let endpoint = '';
      
      switch(type) {
        case 'users':
          endpoint = `/api/admin/users/${id}`;
          break;
        case 'alumni':
          endpoint = `/api/admin/alumni/${id}`;
          break;
        case 'news':
          endpoint = `/api/admin/news/${id}`;
          break;
        case 'partners':
          endpoint = `/api/admin/partners/${id}`;
          break;
        case 'stories':
          endpoint = `/api/admin/success-stories/${id}`;
          break;
        default:
          return;
      }
      
      const response = await fetch(endpoint, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        alert('Элемент успешно удален');
        await loadTabData(type);
        loadStats();
      } else if (response.status === 401 || response.status === 403) {
        handleLogout();
      } else {
        const data = await response.json();
        alert(data.error || 'Ошибка при удалении');
      }
    } catch (err) {
      console.error('Ошибка удаления:', err);
      alert('Ошибка при удалении');
    }
  };

  const handleApproveRequest = async (id) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/alumni-requests/${id}/approve`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        alert('Заявка одобрена, выпускник добавлен');
        await loadTabData('requests');
        await loadTabData('alumni');
        loadStats();
      } else if (response.status === 401 || response.status === 403) {
        handleLogout();
      }
    } catch (err) {
      console.error('Ошибка:', err);
      alert('Ошибка при одобрении заявки');
    }
  };

  const handleRejectRequest = async (id) => {
    const reason = prompt('Укажите причину отклонения (необязательно):');
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/alumni-requests/${id}/reject`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ reason })
      });
      
      if (response.ok) {
        alert('Заявка отклонена');
        await loadTabData('requests');
      } else if (response.status === 401 || response.status === 403) {
        handleLogout();
      }
    } catch (err) {
      console.error('Ошибка:', err);
      alert('Ошибка при отклонении заявки');
    }
  };
  // Добавьте эту функцию после handleRejectRequest
const handleResetPassword = async (user) => {
  const newPassword = prompt(`Введите новый пароль для пользователя ${user.fio}:`, '123456');
  
  if (!newPassword) return;
  
  if (newPassword.length < 4) {
    alert('Пароль должен быть не менее 4 символов');
    return;
  }
  
  try {
    const token = localStorage.getItem('adminToken');
    const response = await fetch(`/api/admin/users/${user.id}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ password: newPassword })
    });
    
    if (response.ok) {
      alert(`Пароль для пользователя ${user.fio} успешно изменен на: ${newPassword}`);
    } else if (response.status === 401 || response.status === 403) {
      handleLogout();
    } else {
      const data = await response.json();
      alert(data.error || 'Ошибка при сбросе пароля');
    }
  } catch (err) {
    console.error('Ошибка сброса пароля:', err);
    alert('Ошибка при сбросе пароля');
  }
};

  const getPendingRequestsCount = () => {
    return requests.filter(r => r.status === 'pending').length;
  };

  // Функции фильтрации
  const getFilteredUsers = () => {
    if (!searchUsers) return users;
    return users.filter(item => 
      item.fio?.toLowerCase().includes(searchUsers.toLowerCase()) ||
      item.email?.toLowerCase().includes(searchUsers.toLowerCase())
    );
  };

  const getFilteredAlumni = () => {
    if (!searchAlumni) return alumni;
    return alumni.filter(item => 
      item.fio?.toLowerCase().includes(searchAlumni.toLowerCase())
    );
  };

  const getFilteredNews = () => {
    if (!searchNews) return news;
    return news.filter(item => 
      item.title?.toLowerCase().includes(searchNews.toLowerCase())
    );
  };

  const getFilteredPartners = () => {
    if (!searchPartners) return partners;
    return partners.filter(item => 
      item.name?.toLowerCase().includes(searchPartners.toLowerCase())
    );
  };

  const getFilteredStories = () => {
    if (!searchStories) return stories;
    return stories.filter(item => 
      item.name?.toLowerCase().includes(searchStories.toLowerCase())
    );
  };

  // Рендер модального окна
  const renderModal = () => {
    if (!showModal) return null;

    return (
      <div className="modal-overlay" onClick={() => setShowModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>{editingItem ? 'Редактировать' : 'Добавить'} {
              modalType === 'user' ? 'пользователя' :
              modalType === 'alumni' ? 'выпускника' :
              modalType === 'news' ? 'новость' :
              modalType === 'partner' ? 'партнера' : 'историю успеха'
            }</h3>
            <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
          </div>
          <div className="modal-body">
            <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
              
              {modalType !== 'user' && (
                <div className="form-group">
                  <label>{modalType === 'partner' ? 'Логотип' : 'Фотография'}</label>
                  <div className="image-upload-container">
                    {imagePreview && (
                      <div className="image-preview">
                        <img src={imagePreview} alt="Preview" />
                      </div>
                    )}
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="form-control"
                    />
                    <small className="form-text text-muted">
                      Поддерживаемые форматы: JPG, PNG, GIF, WEBP. Максимальный размер: 5 MB
                    </small>
                  </div>
                </div>
              )}

              {modalType === 'user' && (
                <>
                  <div className="form-group">
                    <label>ФИО</label>
                    <input type="text" name="fio" value={formData.fio || ''} onChange={handleInputChange} className="form-control" required />
                  </div>
                  <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email || ''} onChange={handleInputChange} className="form-control" required />
                  </div>
                  <div className="form-group">
                    <label>Телефон</label>
                    <input type="text" name="phone" value={formData.phone || ''} onChange={handleInputChange} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Университет</label>
                    <input type="text" name="university" value={formData.university || ''} onChange={handleInputChange} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Роль</label>
                    <select name="role" value={formData.role || 'user'} onChange={handleInputChange} className="form-control">
                      <option value="user">Пользователь</option>
                      <option value="admin">Администратор</option>
                    </select>
                  </div>
                </>
              )}

              {modalType === 'alumni' && (
                <>
                  <div className="form-row">
                    <div className="form-group">
                      <label>ФИО *</label>
                      <input type="text" name="fio" value={formData.fio || ''} onChange={handleInputChange} className="form-control" required />
                    </div>
                    <div className="form-group">
                      <label>Email</label>
                      <input type="email" name="email" value={formData.email || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Направление</label>
                      <input type="text" name="direction" value={formData.direction || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Специальность</label>
                      <input type="text" name="specialty" value={formData.specialty || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Год поступления</label>
                      <input type="number" name="performance_year" value={formData.performance_year || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Год выпуска</label>
                      <input type="number" name="graduation_year" value={formData.graduation_year || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Телефон</label>
                      <input type="text" name="phone" value={formData.phone || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Локация</label>
                      <input type="text" name="location" value={formData.location || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Должность</label>
                      <input type="text" name="position" value={formData.position || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Место работы</label>
                      <input type="text" name="workplace" value={formData.workplace || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>LinkedIn</label>
                      <input type="url" name="linkedin" value={formData.linkedin || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Facebook</label>
                      <input type="url" name="facebook" value={formData.facebook || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                </>
              )}

              {modalType === 'news' && (
                <>
                  <div className="form-group">
                    <label>Заголовок *</label>
                    <input type="text" name="title" value={formData.title || ''} onChange={handleInputChange} className="form-control" required />
                  </div>
                  <div className="form-group">
                    <label>Описание</label>
                    <textarea name="description" value={formData.description || ''} onChange={handleInputChange} className="form-control" rows="3" />
                  </div>
                  <div className="form-group">
                    <label>Содержание</label>
                    <textarea name="content" value={formData.content || ''} onChange={handleInputChange} className="form-control" rows="5" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Дата публикации</label>
                      <input type="date" name="date" value={formData.date || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input type="checkbox" name="is_published" checked={formData.is_published || false} onChange={handleInputChange} />
                        <span>Опубликовано</span>
                      </label>
                    </div>
                  </div>
                </>
              )}

              {modalType === 'partner' && (
                <>
                  <div className="form-group">
                    <label>Название организации *</label>
                    <input type="text" name="name" value={formData.name || ''} onChange={handleInputChange} className="form-control" required />
                  </div>
                  <div className="form-group">
                    <label>Описание</label>
                    <textarea name="description" value={formData.description || ''} onChange={handleInputChange} className="form-control" rows="3" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Веб-сайт</label>
                      <input type="url" name="website_url" value={formData.website_url || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Категория</label>
                      <input type="text" name="category" value={formData.category || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Порядок отображения</label>
                      <input type="number" name="display_order" value={formData.display_order || 0} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group checkbox-group">
                      <label className="checkbox-label">
                        <input type="checkbox" name="is_featured" checked={formData.is_featured || false} onChange={handleInputChange} />
                        <span>Рекомендованный партнер</span>
                      </label>
                    </div>
                  </div>
                </>
              )}

              {modalType === 'story' && (
                <>
                  <div className="form-group">
                    <label>Имя *</label>
                    <input type="text" name="name" value={formData.name || ''} onChange={handleInputChange} className="form-control" required />
                  </div>
                  <div className="form-group">
                    <label>Роль / Должность</label>
                    <input type="text" name="role" value={formData.role || ''} onChange={handleInputChange} className="form-control" />
                  </div>
                  <div className="form-group">
                    <label>Описание</label>
                    <textarea name="description" value={formData.description || ''} onChange={handleInputChange} className="form-control" rows="3" />
                  </div>
                  <div className="form-group">
                    <label>Год выпуска</label>
                    <input type="text" name="graduation" value={formData.graduation || ''} onChange={handleInputChange} className="form-control" />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Категория</label>
                      <input type="text" name="category" value={formData.category || ''} onChange={handleInputChange} className="form-control" />
                    </div>
                    <div className="form-group">
                      <label>Порядок отображения</label>
                      <input type="number" name="display_order" value={formData.display_order || 0} onChange={handleInputChange} className="form-control" />
                    </div>
                  </div>
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input type="checkbox" name="is_featured" checked={formData.is_featured || false} onChange={handleInputChange} />
                      <span>Рекомендованная история</span>
                    </label>
                  </div>
                </>
              )}

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Отмена</button>
                <button type="submit" className="btn btn-primary">Сохранить</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="admin-container">
      <div className="admin-header">
        <div>
          <h1>Панель управления</h1>
          <p className="admin-subtitle">Система управления контентом ОшТУ</p>
        </div>
        <div className="admin-user-info">
          <span className="admin-user-name">{user?.fio || 'Администратор'}</span>
          <button onClick={handleLogout} className="btn btn-outline-danger">Выйти</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card" onClick={() => setActiveTab('users')}>
          <div className="stat-number">{stats.users}</div>
          <div className="stat-label">Пользователи</div>
        </div>
        <div className="stat-card" onClick={() => setActiveTab('news')}>
          <div className="stat-number">{stats.news}</div>
          <div className="stat-label">Новости</div>
        </div>
        <div className="stat-card" onClick={() => setActiveTab('alumni')}>
          <div className="stat-number">{stats.alumni}</div>
          <div className="stat-label">Выпускники</div>
        </div>
        <div className="stat-card" onClick={() => setActiveTab('partners')}>
          <div className="stat-number">{stats.partners}</div>
          <div className="stat-label">Партнеры</div>
        </div>
        <div className="stat-card" onClick={() => setActiveTab('stories')}>
          <div className="stat-number">{stats.stories || 0}</div>
          <div className="stat-label">Истории успеха</div>
        </div>
        <div className="stat-card" onClick={() => setActiveTab('requests')}>
          <div className="stat-number">{getPendingRequestsCount()}</div>
          <div className="stat-label">Заявки на рассмотрении</div>
        </div>
      </div>

      <div className="admin-tabs">
        <button className={`tab ${activeTab === 'dashboard' ? 'active' : ''}`} onClick={() => setActiveTab('dashboard')}>
          Обзор
        </button>
        <button className={`tab ${activeTab === 'users' ? 'active' : ''}`} onClick={() => setActiveTab('users')}>
          Пользователи
        </button>
        <button className={`tab ${activeTab === 'alumni' ? 'active' : ''}`} onClick={() => setActiveTab('alumni')}>
          Выпускники
        </button>
        <button className={`tab ${activeTab === 'news' ? 'active' : ''}`} onClick={() => setActiveTab('news')}>
          Новости
        </button>
        <button className={`tab ${activeTab === 'partners' ? 'active' : ''}`} onClick={() => setActiveTab('partners')}>
          Партнеры
        </button>
        <button className={`tab ${activeTab === 'stories' ? 'active' : ''}`} onClick={() => setActiveTab('stories')}>
          Истории успеха
        </button>
        <button className={`tab ${activeTab === 'requests' ? 'active' : ''}`} onClick={() => setActiveTab('requests')}>
          Заявки
          {getPendingRequestsCount() > 0 && (
            <span className="tab-badge">{getPendingRequestsCount()}</span>
          )}
        </button>
      </div>

      <div className="admin-panel">
        {loading && <div className="loading-spinner">Загрузка данных...</div>}
        {error && <div className="error-message">{error}</div>}
        
        {!loading && !error && (
          <>
            {activeTab === 'dashboard' && (
              <div className="dashboard">
                <h2>Обзор системы</h2>
                <p className="dashboard-description">Добро пожаловать в панель управления сайтом Ошского технологического университета</p>
                <div className="quick-actions">
                  <h3>Быстрые действия</h3>
                  <div className="action-buttons">
                    <button className="btn btn-primary" onClick={() => handleAdd('news')}>Добавить новость</button>
                    <button className="btn btn-success" onClick={() => handleAdd('alumni')}>Добавить выпускника</button>
                    <button className="btn btn-warning" onClick={() => handleAdd('partner')}>Добавить партнера</button>
                    <button className="btn btn-info" onClick={() => handleAdd('story')}>Добавить историю</button>
                  </div>
                </div>
              </div>
            )}

           {activeTab === 'users' && (
  <div className="table-section">
    <div className="section-header">
      <h2>Управление пользователями</h2>
      <div className="d-flex gap-2">
        <input
          type="text"
          className="form-control"
          placeholder="Поиск по ФИО или Email..."
          value={searchUsers}
          onChange={(e) => setSearchUsers(e.target.value)}
          style={{ width: '250px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
        />
        <button className="btn btn-primary" onClick={() => handleAdd('user')}>Добавить пользователя</button>
      </div>
    </div>
    <div className="table-container">
      <table className="data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>ФИО</th>
            <th>Email</th>
            <th>Телефон</th>
            <th>Университет</th>
            <th>Роль</th>
            <th>Пароль</th>
            <th>Действия</th>
           </tr>
        </thead>
        <tbody>
          {getFilteredUsers().length > 0 ? (
            getFilteredUsers().map(userItem => (
              <tr key={userItem.id}>
                <td>{userItem.id}</td>
                <td>{userItem.fio}</td>
                <td>{userItem.email}</td>
                <td>{userItem.phone || '-'}</td>
                <td>{userItem.university || '-'}</td>
                <td>
                  <span className={`status-badge ${userItem.role === 'admin' ? 'status-admin' : 'status-user'}`}>
                    {userItem.role === 'admin' ? 'Администратор' : 'Пользователь'}
                  </span>
                </td>
                <td>
                  <button 
                    className="action-btn password-btn" 
                    onClick={() => handleResetPassword(userItem)}
                    style={{ background: '#ff9800', color: 'white', marginRight: '5px' }}
                  >
                    Сбросить пароль
                  </button>
                </td>
                <td>
                  <button className="action-btn edit-btn" onClick={() => handleEdit('user', userItem)}>Редактировать</button>
                  <button className="action-btn delete-btn" onClick={() => handleDelete('users', userItem.id)} disabled={userItem.id === user?.id}>Удалить</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="empty-table">Нет данных для отображения</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}

            {activeTab === 'alumni' && (
              <div className="table-section">
                <div className="section-header">
                  <h2>Управление выпускниками</h2>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Поиск по ФИО..."
                      value={searchAlumni}
                      onChange={(e) => setSearchAlumni(e.target.value)}
                      style={{ width: '250px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
                    />
                    <button className="btn btn-primary" onClick={() => handleAdd('alumni')}>Добавить выпускника</button>
                  </div>
                </div>
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Фото</th>
                        <th>ФИО</th>
                        <th>Направление</th>
                        <th>Специальность</th>
                        <th>Год выпуска</th>
                        <th>Должность</th>
                        <th>Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredAlumni().length > 0 ? (
                        getFilteredAlumni().map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td className="table-avatar-cell">
                              {item.image_url ? (
                                <img src={item.image_url} alt={item.fio} className="table-avatar" />
                              ) : (
                                <div className="table-avatar-placeholder"></div>
                              )}
                            </td>
                            <td>{item.fio}</td>
                            <td>{item.direction || '-'}</td>
                            <td>{item.specialty || '-'}</td>
                            <td>{item.graduation_year || '-'}</td>
                            <td>{item.position || '-'}</td>
                            <td>
                              <button className="action-btn edit-btn" onClick={() => handleEdit('alumni', item)}>Редактировать</button>
                              <button className="action-btn delete-btn" onClick={() => handleDelete('alumni', item.id)}>Удалить</button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="8" className="empty-table">Нет данных для отображения</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeTab === 'news' && (
              <div className="table-section">
                <div className="section-header">
                  <h2>Управление новостями</h2>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Поиск по заголовку..."
                      value={searchNews}
                      onChange={(e) => setSearchNews(e.target.value)}
                      style={{ width: '250px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
                    />
                    <button className="btn btn-primary" onClick={() => handleAdd('news')}>Добавить новость</button>
                  </div>
                </div>
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Изображение</th>
                        <th>Заголовок</th>
                        <th>Дата</th>
                        <th>Просмотры</th>
                        <th>Статус</th>
                        <th>Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredNews().length > 0 ? (
                        getFilteredNews().map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td className="table-image-cell">
                              {item.image_url ? (
                                <img src={item.image_url} alt={item.title} className="table-image" />
                              ) : (
                                <div className="table-image-placeholder"></div>
                              )}
                            </td>
                            <td>{item.title}</td>
                            <td>{item.date ? new Date(item.date).toLocaleDateString() : '-'}</td>
                            <td>{item.views_count || 0}</td>
                            <td>
                              <span className={`status-badge ${item.is_published ? 'status-published' : 'status-draft'}`}>
                                {item.is_published ? 'Опубликовано' : 'Черновик'}
                              </span>
                            </td>
                            <td>
                              <button className="action-btn edit-btn" onClick={() => handleEdit('news', item)}>Редактировать</button>
                              <button className="action-btn delete-btn" onClick={() => handleDelete('news', item.id)}>Удалить</button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="empty-table">Нет данных для отображения</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeTab === 'partners' && (
              <div className="table-section">
                <div className="section-header">
                  <h2>Управление партнерами</h2>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Поиск по названию..."
                      value={searchPartners}
                      onChange={(e) => setSearchPartners(e.target.value)}
                      style={{ width: '250px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
                    />
                    <button className="btn btn-primary" onClick={() => handleAdd('partner')}>Добавить партнера</button>
                  </div>
                </div>
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Логотип</th>
                        <th>Название</th>
                        <th>Сайт</th>
                        <th>Категория</th>
                        <th>Рекомендованный</th>
                        <th>Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredPartners().length > 0 ? (
                        getFilteredPartners().map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td className="table-image-cell">
                              {item.logo_url ? (
                                <img src={item.logo_url} alt={item.name} className="table-logo" />
                              ) : (
                                <div className="table-image-placeholder"></div>
                              )}
                            </td>
                            <td>{item.name}</td>
                            <td>
                              {item.website_url && (
                                <a href={item.website_url} target="_blank" rel="noopener noreferrer" className="link">Веб-сайт</a>
                              )}
                            </td>
                            <td>{item.category || '-'}</td>
                            <td>{item.is_featured ? 'Да' : 'Нет'}</td>
                            <td>
                              <button className="action-btn edit-btn" onClick={() => handleEdit('partner', item)}>Редактировать</button>
                              <button className="action-btn delete-btn" onClick={() => handleDelete('partners', item.id)}>Удалить</button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="empty-table">Нет данных для отображения</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeTab === 'stories' && (
              <div className="table-section">
                <div className="section-header">
                  <h2>Управление историями успеха</h2>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Поиск по имени..."
                      value={searchStories}
                      onChange={(e) => setSearchStories(e.target.value)}
                      style={{ width: '250px', borderRadius: '8px', border: '1px solid #e2e8f0' }}
                    />
                    <button className="btn btn-primary" onClick={() => handleAdd('story')}>Добавить историю</button>
                  </div>
                </div>
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Фото</th>
                        <th>Имя</th>
                        <th>Роль</th>
                        <th>Категория</th>
                        <th>Рекомендованный</th>
                        <th>Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getFilteredStories().length > 0 ? (
                        getFilteredStories().map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td className="table-avatar-cell">
                              {item.image_url ? (
                                <img src={item.image_url} alt={item.name} className="table-avatar" />
                              ) : (
                                <div className="table-avatar-placeholder"></div>
                              )}
                            </td>
                            <td>{item.name}</td>
                            <td>{item.role || '-'}</td>
                            <td>{item.category || '-'}</td>
                            <td>{item.is_featured ? 'Да' : 'Нет'}</td>
                            <td>
                              <button className="action-btn edit-btn" onClick={() => handleEdit('story', item)}>Редактировать</button>
                              <button className="action-btn delete-btn" onClick={() => handleDelete('stories', item.id)}>Удалить</button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="empty-table">Нет данных для отображения</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {activeTab === 'requests' && (
              <div className="table-section">
                <div className="section-header">
                  <h2>Заявки на вступление в ассоциацию</h2>
                </div>
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>ФИО</th>
                        <th>Email</th>
                        <th>Телефон</th>
                        <th>Направление</th>
                        <th>Специальность</th>
                        <th>Год выпуска</th>
                        <th>Статус</th>
                        <th>Дата</th>
                        <th>Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {requests.length > 0 ? (
                        requests.map(item => (
                          <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>{item.fio}</td>
                            <td>{item.email}</td>
                            <td>{item.phone || '-'}</td>
                            <td>{item.direction || '-'}</td>
                            <td>{item.specialty || '-'}</td>
                            <td>{item.graduation_year || '-'}</td>
                            <td>
                              <span className={`status-badge ${
                                item.status === 'approved' ? 'status-approved' :
                                item.status === 'rejected' ? 'status-rejected' : 'status-pending'
                              }`}>
                                {item.status === 'approved' ? 'Одобрено' :
                                 item.status === 'rejected' ? 'Отклонено' : 'На рассмотрении'}
                              </span>
                            </td>
                            <td>{item.created_at ? new Date(item.created_at).toLocaleDateString() : '-'}</td>
                            <td>
                              {item.status === 'pending' && (
                                <div className="action-buttons-group">
                                  <button className="action-btn approve-btn" onClick={() => handleApproveRequest(item.id)}>Одобрить</button>
                                  <button className="action-btn reject-btn" onClick={() => handleRejectRequest(item.id)}>Отклонить</button>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="10" className="empty-table">Нет данных для отображения</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {renderModal()}
    </div>
  );
};

export default AdminPanel;